/* wl-drawer.js — l'habilleur du tiroir panier (26/08/2026).
   La maquette validee par le proprietaire : etiquette en petites
   capitales, carte du kit de fixation avec sa photo, « CHEZ VOUS LE »
   reflete du calculateur de la fiche (jamais recalcule), tampon
   Protection Walensky, total en carte glace, rien sous le bouton.
   Les textes traduits et l'image du kit arrivent par window.WLDR
   (ilot inline du snippet). Le tiroir d'origine n'est pas modifie :
   on masque, on habille, on injecte — tout est reversible. */
(function () {
  'use strict';
  var T = window.WLDR || {};

  function estUneDate(t) {
    return !!t && /\d/.test(t) && /[^\d\s.,\/-]/.test(t);   /* 28/09 : toute ecriture (grec, cyrillique), plus seulement le latin */
  }

  /* L'etiquette : « Verre Acrylique / XXL 160x90cm » devient
     « Verre Acrylique — 160 × 90 cm ». La taille se reconnait a ses
     CHIFFRESxCHIFFRES, jamais a un mot. Les noms de support : Shopify
     ne les traduit que la ou l'app est passee (de/en/it/nl, et encore) ;
     la table sup de l'ilot rattrape les autres langues — elle ne mord
     QUE sur le francais brut, jamais sur une valeur deja traduite. */
  function etiqueter(p) {
    if (!p || p.dataset.wldrFait === '1') { return; }
    var brut = (p.textContent || '').replace(/\s+/g, ' ').trim();
    if (!brut) { return; }
    var S = window.WLDR || {};
    var sup = { 'Verre Acrylique': S.supVA, 'Alu Dibond': S.supAD,
                'Alu Dibond brossé': S.supADB };
    var parties = brut.split('/').map(function (x) { return x.trim(); });
    var morceaux = [];
    for (var i = 0; i < parties.length; i++) {
      var m = parties[i].match(/(\d+)\s*[x×]\s*(\d+)\s*cm/i);
      if (m) { morceaux.push(m[1] + ' × ' + m[2] + ' cm'); }
      else if (parties[i]) { morceaux.push(sup[parties[i]] || parties[i]); }
    }
    p.dataset.wldrFait = '1';
    p.textContent = morceaux.join(' — ');
    p.classList.add('wldr-caps');
  }

  /* ---- le code promo -------------------------------------------------
     Shopify n'offre aucun champ de code hors du checkout : on passe par
     ses trois portes officieuses, verifiees le 27/08 sur la boutique.
     On pose par fetch, puis on demande au theme de RELIRE SA SECTION
     (evenement « cart:refresh ») : le tiroir se met a jour sur place et
     reste ouvert. Recharger la page, comme au premier jet, fermait le
     tiroir deux secondes et ramenait la fiche produit — pas serieux. */
  var JETON = 'wldrPromoRouvrir';

  /* Rouvrir : le tiroir du theme est un element personnalise qui expose
     show(). Sur une fiche produit il n'existe AUCUN bouton
     [aria-controls="cart-drawer"] — s'y fier laissait le tiroir ferme.
     On attend que l'element soit reveille (show() apparait a ce
     moment-la), puis on l'ouvre ; le bouton reste un secours. */
  function rouvrirLeTiroir() {
    var marque = null;
    try { marque = sessionStorage.getItem(JETON); } catch (e) { return; }
    if (marque !== '1') { return; }
    try { sessionStorage.removeItem(JETON); } catch (e2) {}
    var essais = 0;
    var tenter = function () {
      var tiroir = document.querySelector('cart-drawer');
      if (tiroir && typeof tiroir.show === 'function') {
        try { tiroir.show(); return; } catch (e3) { /* on tente le bouton */ }
      }
      var ouvreur = document.querySelector('[aria-controls="cart-drawer"]');
      if (ouvreur) { ouvreur.click(); return; }
      if (++essais < 12) { setTimeout(tenter, 250); }
    };
    setTimeout(tenter, 350);
  }

  /* Rafraichir SANS recharger la page. Le theme ecoute « cart:refresh »
     et sait relire sa propre section pour remplacer le contenu du
     tiroir : le tiroir reste ouvert, rien ne clignote. On ne recharge
     que si l'evenement n'existe pas (vieux navigateur), et dans ce cas
     seulement on pose le jeton qui rouvrira le tiroir. */
  /* La modale « taille sur mesure » affichait sa propre confirmation
     apres l'ajout (etat #wlk-success). Demande du 27/08 : elle doit
     ouvrir le tiroir a la place. On GUETTE l'apparition de cet etat,
     on referme la modale par son propre bouton, puis on ouvre le
     tiroir — le fichier de la modale n'est pas touche. Elle appelle
     deja « cart:refresh » de son cote, donc le tiroir sera a jour. */
  function guetterTaillePerso() {
    var succes = document.getElementById('wlk-success');
    if (!succes || succes.dataset.wldrGuet === '1') { return false; }
    succes.dataset.wldrGuet = '1';
    new MutationObserver(function () {
      if (!succes.classList.contains('show')) { return; }
      window.setTimeout(function () {
        var fermer = document.getElementById('wlk-popup-close');
        if (fermer) { fermer.click(); }
        window.setTimeout(function () {
          var tiroir = document.querySelector('cart-drawer');
          if (tiroir && typeof tiroir.show === 'function') {
            try { tiroir.show(); } catch (e) { /* tant pis, le panier est bon */ }
          }
        }, 260);
      }, 140);
    }).observe(succes, { attributes: true, attributeFilter: ['class'] });
    return true;
  }

  function rafraichirLeTiroir() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    } catch (e) { /* on retombe sur le rechargement */ }
    try { sessionStorage.setItem(JETON, '1'); } catch (e2) {}
    window.location.reload();
  }

  function sou(centimes, monnaie) {
    try {
      return (centimes / 100).toLocaleString(document.documentElement.lang || 'fr',
        { style: 'currency', currency: monnaie || 'EUR' });
    } catch (e) { return ''; }
  }

  /* Un code applique : le prix d'AVANT, barre, devant le nouveau. Le
     montant vient du serveur ; on ne le reecrit que s'il n'a pas suivi
     la remise (comparaison sur les seuls chiffres — les formats de
     monnaie changent d'une boutique a l'autre). */
  function montrerAncienPrix(totaux, c) {
    if (!totaux || !c || !(c.total_discount > 0)) { return; }
    /* PIEGE : quand une remise s'applique, le theme insere SA PROPRE
       ligne (« -12,00 € ») AVANT celle du total ; elle ne porte aucun
       .h5. On prend donc la DERNIERE ligne qui en porte un. */
    var lignes = totaux.querySelectorAll('.h-stack');
    var montant = null;
    for (var i = 0; i < lignes.length; i++) {
      var h5 = lignes[i].querySelectorAll('.h5');
      if (h5.length) { montant = h5[h5.length - 1]; }
    }
    if (!montant || montant.dataset.wldrAvant === '1') { return; }
    var avant = sou(c.original_total_price, c.currency);
    if (!avant) { return; }
    montant.dataset.wldrAvant = '1';
    var chiffres = (montant.textContent || '').replace(/\D/g, '');
    if (chiffres === String(c.original_total_price)) {
      montant.textContent = sou(c.total_price, c.currency);
    }
    /* les deux prix s'empilent : l'ancien barre au-dessus, le nouveau
       dessous, cales a droite — cote a cote ils se telescopaient dans
       les 146 px de la colonne. */
    montant.classList.add('wldr-total-remise');
    /* la ligne entiere se cale en bas : « Total » doit s'aligner
       sur le prix REEL, pas flotter entre les deux lignes. */
    var rangeeTotal = montant.closest('.h-stack');
    if (rangeeTotal) { rangeeTotal.classList.add('wldr-ligne-remise'); }
    var barre = document.createElement('s');
    barre.className = 'wldr-avant';
    barre.textContent = avant;
    montant.insertBefore(barre, montant.firstChild);
  }

  function promoDansTiroir(totaux, T) {
    if (!totaux || totaux.querySelector('.wldr-promo')) { return; }
    var promo = document.createElement('div');
    promo.className = 'wldr-promo';
    promo.innerHTML =
      '<button type="button" class="wldr-promo-lien" aria-expanded="false">' +
      '<span class="wldr-promo-titre">' + (T.promoQ || 'Vous avez un code promo ?') + '</span>' +
      '<svg class="wldr-promo-chevron" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">' +
      '<path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2"' +
      ' stroke-linecap="round" stroke-linejoin="round"></path></svg></button>' +
      '<div class="wldr-promo-champ" hidden>' +
      '<input type="text" class="wldr-promo-saisie" autocomplete="off" spellcheck="false"' +
      ' aria-label="' + (T.promoPh || 'Code promo') + '"' +
      ' placeholder="' + (T.promoPh || 'Code promo') + '">' +
      '<button type="button" class="wldr-promo-ok">' + (T.promoBtn || 'Appliquer') + '</button>' +
      '</div><p class="wldr-promo-mot" hidden></p>';
    totaux.insertBefore(promo, totaux.firstChild);

    var lien = promo.querySelector('.wldr-promo-lien');
    var champ = promo.querySelector('.wldr-promo-champ');
    var saisie = promo.querySelector('.wldr-promo-saisie');
    var valider = promo.querySelector('.wldr-promo-ok');
    var mot = promo.querySelector('.wldr-promo-mot');

    /* un onglet : l'en-tete reste, le chevron tourne */
    lien.addEventListener('click', function () {
      var ouvrir = champ.hidden;
      champ.hidden = !ouvrir;
      lien.setAttribute('aria-expanded', ouvrir ? 'true' : 'false');
      if (ouvrir) { saisie.focus(); }
    });
    var poser = function () {
      var code = (saisie.value || '').trim();
      if (!code) { saisie.focus(); return; }
      valider.disabled = true;
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .then(function () { rafraichirLeTiroir(); })
        .catch(function () { valider.disabled = false; });
    };
    valider.addEventListener('click', poser);
    saisie.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') { ev.preventDefault(); poser(); }
    });

    if (!window.fetch) { return; }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var codes = c.discount_codes || [];
        if (!codes.length) { return; }
        var pose = codes[0];
        champ.hidden = false;
        lien.setAttribute('aria-expanded', 'true');
        mot.hidden = false;
        montrerAncienPrix(totaux, c);
        saisie.value = pose.code;
        if (pose.applicable) {
          var somme = '';
          try {
            somme = (c.total_discount / 100).toLocaleString(
              document.documentElement.lang || 'fr',
              { style: 'currency', currency: c.currency || 'EUR' });
          } catch (e3) { somme = ''; }
          mot.className = 'wldr-promo-mot wldr-promo-ok-mot';
          mot.textContent = (T.promoOk || 'Code appliqué') + ' · ' + pose.code +
            (c.total_discount > 0 ? ' · −' + somme : '');
          saisie.disabled = true;
          var oter = document.createElement('button');
          oter.type = 'button';
          oter.className = 'wldr-promo-oter';
          oter.textContent = T.promoDel || 'Retirer';
          oter.addEventListener('click', function () {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ discount: '' })
            }).then(rafraichirLeTiroir);
          });
          mot.appendChild(document.createTextNode(' '));
          mot.appendChild(oter);
        } else {
          mot.className = 'wldr-promo-mot wldr-promo-faux';
          mot.textContent = (T.promoErr || 'Code non valable') + ' · ' + pose.code;
        }
      })
      .catch(function () {});
  }

  function bloc(html, marque) {
    var d = document.createElement('div');
    d.className = marque;
    d.innerHTML = html;
    return d;
  }

  function habiller() {
    try { habillerInterne(); }
    catch (err) {
      if (window.location.search.indexOf('wldebug') > -1) {
        var db = document.getElementById('wldrDebug') || document.createElement('div');
        db.id = 'wldrDebug';
        db.style.cssText = 'position:fixed;left:4px;bottom:4px;z-index:2147483300;' +
          'background:#000;color:#f66;font:10px/1.5 monospace;padding:6px 8px;' +
          'border-radius:6px;max-width:92vw;white-space:pre-wrap;pointer-events:none';
        db.textContent = 'ERREUR: ' + (err && err.message) + '\n' + String(err && err.stack).slice(0, 300);
        document.body.appendChild(db);
      }
    }
  }

  function habillerInterne() {
    var tiroir = document.querySelector('cart-drawer');
    if (!tiroir) { return; }
    var inner = tiroir.querySelector('.cart-drawer__inner');
    var pied = null;
    var enfants = tiroir.children;
    for (var i = 0; i < enfants.length; i++) {
      if (enfants[i] !== inner && enfants[i].classList.contains('v-stack')) { pied = enfants[i]; }
    }
    if (!inner || !pied) { return; }

    /* 1 — les etiquettes de chaque article */
    var variantes = tiroir.querySelectorAll('line-item .line-item__info > p.text-sm');
    for (var v = 0; v < variantes.length; v++) { etiqueter(variantes[v]); }

    /* 1bis — sur telephone, la rangee « prix · quantite · supprimer » :
       le prix quitte l'en-tete du titre, la case de quantite (celle du
       telephone) et le lien Supprimer viennent a sa droite. */
    if (!window.matchMedia('(min-width: 1000px)').matches) {
      var infos = tiroir.querySelectorAll('line-item .line-item__info');
      for (var w = 0; w < infos.length; w++) {
        var info = infos[w];
        if (info.dataset.wldrRang === '1') { continue; }
        var prixL = info.querySelector('price-list');
        var qte = null;
        var qtes = info.querySelectorAll('line-item-quantity');
        for (var q = 0; q < qtes.length; q++) {
          if (qtes[q].closest('.line-item__actions') === null) { qte = qtes[q]; }
        }
        if (!prixL || !qte) { continue; }
        info.dataset.wldrRang = '1';
        var rang = document.createElement('div');
        rang.className = 'wldr-rang';
        info.appendChild(rang);
        rang.appendChild(prixL);
        rang.appendChild(qte);
      }
    }

    /* 2 — le pied : on garde le bloc des totaux et le formulaire, on
       eteint le reste (l'ancienne reassurance, les pictogrammes). Le
       reperage est STRUCTUREL, pas textuel : les libelles changent de
       langue, pas la charpente. */
    var directs = pied.children;
    var totaux = null, formulaire = null;
    for (var j = 0; j < directs.length; j++) {
      var e = directs[j];
      if (!totaux && e.classList.contains('v-stack')) { totaux = e; continue; }
      if (e.tagName === 'FORM') { formulaire = e; continue; }
      if (e.classList.contains('wldr-chez') || e.classList.contains('wldr-tampon-porte') ||
          e.classList.contains('wldr-kit')) { continue; }
      if (e.dataset.wldrOff !== '1') {
        e.dataset.wldrOff = '1';
        e.style.setProperty('display', 'none', 'important');
      }
    }
    if (totaux && !totaux.classList.contains('wldr-glace')) {
      totaux.classList.add('wldr-glace');
    }
    /* DOUBLON : quand un code s'applique, le theme ajoute SA ligne
       (pastille du code + montant) juste au-dessus du total, alors que
       notre bloc promo dit deja la meme chose ET porte le « Retirer ».
       On eteint la sienne — reperage structurel (une .h-stack qui porte
       une pastille .badge), jamais textuel. */
    if (totaux) {
      var rangees = totaux.querySelectorAll('.h-stack');
      for (var w = 0; w < rangees.length; w++) {
        if (rangees[w].querySelector('.badge') && rangees[w].dataset.wldrDbl !== '1') {
          rangees[w].dataset.wldrDbl = '1';
          rangees[w].style.setProperty('display', 'none', 'important');
        }
      }
    }

    /* 2 bis — « Total » et la ligne Klarna : du francais fige dans le
       gabarit du theme, hors de portee des traductions Shopify. On
       traduit AUTOUR du montant : le <strong> du serveur (« 3x 109,96 € »)
       et le « Klarna » rose sont detaches puis remis tels quels a la
       place des reperes {m} et {k} du gabarit de la langue — l'ordre des
       mots varie selon la langue. Marqueurs poses sur les noeuds memes :
       un re-rendu du tiroir les remplace, donc on re-traduit ; sinon on
       ne touche a rien (l'observateur ne doit pas boucler). */
    if (totaux && T.tot) {
      var lab = totaux.querySelector('.h-stack .h5');
      if (lab && lab.dataset.wldrTot !== '1' && !/\d/.test(lab.textContent)) {
        lab.dataset.wldrTot = '1';
        lab.textContent = T.tot;
      }
    }
    if (totaux && T.kla && T.kla.indexOf('{m}') > -1 && T.kla.indexOf('{k}') > -1) {
      var lgn = totaux.querySelector('.text-subdued.text-sm');
      if (lgn && lgn.dataset.wldrKla !== '1') {
        var fort = lgn.querySelector('strong');
        var rose = lgn.querySelector('span');
        if (fort && rose) {
          lgn.dataset.wldrKla = '1';
          fort.remove(); rose.remove();
          lgn.textContent = '';
          var jetons = T.kla.split(/(\{m\}|\{k\})/);
          for (var q = 0; q < jetons.length; q++) {
            if (jetons[q] === '{m}') { lgn.appendChild(fort); }
            else if (jetons[q] === '{k}') { lgn.appendChild(rose); }
            else if (jetons[q]) { lgn.appendChild(document.createTextNode(jetons[q])); }
          }
        }
      }
    }

    /* 2 ter — le code promo, dans la carte glace, au-dessus du total.
       REPLIE : sur telephone la place est comptee, un simple lien d'une
       ligne suffit ; il ne s'ouvre qu'au toucher. Memes trois portes que
       la page panier — poser /discount/CODE, relire /cart.js, retirer
       /cart/update.js {discount:''} — a une difference pres : ici on pose
       par fetch puis on RECHARGE (le serveur doit recalculer le total),
       et un jeton rouvre le tiroir pour que le client garde le fil. */
    promoDansTiroir(totaux, T);

    /* 3 — la zone qui defile recoit, sous les articles : la carte du
       kit, le « chez vous le », le tampon. Une seule fois chacun ; si le
       tiroir se re-rend, l'observateur nous rappelle et on les repose. */
    var zone = inner.querySelector('.cart-drawer__line-items');
    if (zone && !tiroir.querySelector('.wldr-kit')) {
      var kit = bloc(
        '<span class="wldr-kit-vig"' + (T.kitImg ? ' style="background-image:url(\'' + T.kitImg + '\')"' : '') + '></span>' +
        '<span class="wldr-kit-tx"><b>' + (T.kitT || 'Kit de fixation inclus') + '</b><br>' +
        '<span>' + (T.kitS || '') + '</span></span>', 'wldr-kit');
      zone.parentElement.insertBefore(kit, zone.nextSibling);
    }
    /* La date et le tampon : sur TELEPHONE ils vivent dans la partie FIXE,
       juste au-dessus du total — visibles quel que soit le nombre
       d'articles (le pli ne les avale plus). Sur ORDINATEUR, ils restent
       dans le fil, sous la carte du kit, comme la maquette validee.
       Le placement se rejoue si la fenetre change de monde. */
    if (totaux && !tiroir.querySelector('.wldr-chez')) {
      pied.insertBefore(bloc(
        '<span class="wldr-chez-l">' + (T.chez || 'Chez vous le') + ' <span class="wldr-date"></span></span>' +
        '<small>' + (T.liv || '') + '</small>', 'wldr-chez'), totaux);
      pied.insertBefore(bloc(
        '<span class="wldr-tampon">' + (T.prot1 || 'Protection Walensky · offerte') +
        '<small>' + (T.prot2 || '') + '</small></span>', 'wldr-tampon-porte'), totaux);
    }
    var chezEl = tiroir.querySelector('.wldr-chez');
    var tamponEl = tiroir.querySelector('.wldr-tampon-porte');
    var kitEl = tiroir.querySelector('.wldr-kit');
    if (chezEl && tamponEl && kitEl) {
      var enBas = !window.matchMedia('(min-width: 1000px)').matches;
      if (enBas) {
        /* telephone : kit + date + tampon dans la partie fixe, au-dessus
           du total — chaque bloc verifie SON propre parent */
        if (chezEl.parentElement !== pied) { pied.insertBefore(chezEl, totaux); }
        if (tamponEl.parentElement !== pied) { pied.insertBefore(tamponEl, totaux); }
        if (kitEl.parentElement !== pied) { pied.insertBefore(kitEl, chezEl); }
        /* AUCUNE hauteur imposee : le defilement appartient au theme.
           (Une borne calculee ici mesurait le pied AVANT le chargement de
           la photo du kit : il grandissait apres coup et recouvrait la
           fin de la liste — une demi-carte toujours inaccessible.) */
        inner.style.removeProperty('max-height');
        inner.style.removeProperty('overflow-y');
        tiroir.style.removeProperty('height');
        tiroir.style.removeProperty('max-height');
      } else if (chezEl.parentElement === pied || kitEl.parentElement === pied) {
        inner.style.removeProperty('max-height');
        inner.style.removeProperty('overflow-y');
        tiroir.style.removeProperty('height');
        tiroir.style.removeProperty('max-height');
        /* ordinateur : les trois retrouvent le fil, sous les articles */
        if (zone) {
          zone.parentElement.insertBefore(kitEl, zone.nextSibling);
          zone.parentElement.insertBefore(chezEl, kitEl.nextSibling);
          zone.parentElement.insertBefore(tamponEl, chezEl.nextSibling);
        }
      }
    }

    /* 4 — la date : LUE dans le calculateur de la fiche, jamais
       recalculee (« deux calculs de calendrier finissent toujours par
       diverger sur un jour ferie »). Refletee en continu : elle bouge
       quand le client change de taille. Sans source (ajout depuis une
       autre page), la ligne du jour s'efface, la livraison offerte reste. */
    var cible = tiroir.querySelector('.wldr-date');
    var chezBloc = tiroir.querySelector('.wldr-chez');
    if (cible && chezBloc) {
      var source = document.querySelector('.fxd__hero-date');
      var texte = source ? (source.textContent || '').replace(/\s+/g, ' ').trim() : '';
      if (estUneDate(texte)) {
        cible.textContent = texte;
        chezBloc.classList.remove('wldr-sans-date');
        if (window.MutationObserver && source.dataset.wldrSuivi !== '1') {
          source.dataset.wldrSuivi = '1';
          new MutationObserver(function () {
            var t2 = (source.textContent || '').replace(/\s+/g, ' ').trim();
            if (estUneDate(t2)) { cible.textContent = t2; }
          }).observe(source, { childList: true, characterData: true, subtree: true });
        }
      } else {
        chezBloc.classList.add('wldr-sans-date');
      }
    }

    /* PAS DE CORRECTION du blanc entre la liste et la partie fixe.
       Essaye le 27/08, retire aussitot : ce blanc n'est pas une marge,
       c'est l'espace libre que le tiroir REPARTIT autour de ses deux
       blocs (mesure : 20 px en haut, 45 au milieu, 24 en bas — le
       partage d'un « space-around »). Remonter le pied lui rend de
       l'espace libre a repartir : la correction se mange elle-meme
       (45 -> 56 px avec une marge de -28). Et ce blanc n'existe QUE
       sur un panier court : des 6 articles il vaut zero, la liste
       passant sous le pied. Rien a gagner, donc on n'y touche pas. */

    /* le guide de defilement suit chaque re-rendu du panier */
    guiderLeScroll(tiroir);

    /* LOUPE DE DIAGNOSTIC : ?wldebug dans l'adresse -> les mesures reelles
       de l'appareil s'affichent dans un encart. A retirer apres enquete. */
    if (window.location.search.indexOf('wldebug') > -1) {
      var dbg = document.getElementById('wldrDebug');
      if (!dbg) {
        dbg = document.createElement('div');
        dbg.id = 'wldrDebug';
        dbg.style.cssText = 'position:fixed;left:4px;bottom:4px;z-index:2147483300;' +
          'background:#000;color:#0f0;font:10px/1.5 monospace;padding:6px 8px;' +
          'border-radius:6px;max-width:92vw;white-space:pre;pointer-events:none;opacity:.92';
        document.body.appendChild(dbg);
      }
      var vv = window.visualViewport;
      var rT = tiroir.getBoundingClientRect();
      var defileurs = [];
      var tousEl = tiroir.querySelectorAll('*');
      for (var z = 0; z < tousEl.length && defileurs.length < 3; z++) {
        if (tousEl[z].scrollHeight > tousEl[z].clientHeight + 6 &&
            /auto|scroll/.test(getComputedStyle(tousEl[z]).overflowY)) {
          defileurs.push((tousEl[z].className || tousEl[z].tagName).toString().split(' ')[0].slice(0, 18) +
            ' ' + tousEl[z].clientHeight + '/' + tousEl[z].scrollHeight);
        }
      }
      dbg.textContent =
        'vv=' + (vv ? Math.round(vv.height) : '-') + ' inH=' + window.innerHeight +
        ' scrY=' + Math.round(window.scrollY) +
        '\ntiroir rect=' + Math.round(rT.height) + ' top=' + Math.round(rT.top) +
        ' style=' + (tiroir.style.height || '-') +
        '\ninner=' + inner.clientHeight + '/' + inner.scrollHeight +
        ' maxH=' + (inner.style.maxHeight || '-') +
        '\npied=' + Math.round(pied.getBoundingClientRect().height) +
        ' bas=' + Math.round(pied.getBoundingClientRect().bottom) +
        ' articles=' + tiroir.querySelectorAll('line-item').length +
        '\ndefileurs: ' + (defileurs.join(' | ') || 'AUCUN');
    }
  }

  /* ===== 3+ articles (telephone) : le voile, la pastille, le rebond ===== */
  function conteneurQuiRoule(tiroir) {
    var inner = tiroir.querySelector('.cart-drawer__inner');
    var candidats = [inner, inner && inner.querySelector('.v-stack'), tiroir];
    for (var i = 0; i < candidats.length; i++) {
      var el = candidats[i];
      if (el && el.scrollHeight > el.clientHeight + 12) { return el; }
    }
    return null;
  }

  /* la fleche : une simple invitation a defiler, quand 3 produits
     differents ou plus sont au panier et que la liste deborde vraiment.
     Elle s'efface des que la personne a defile. */
  function guiderLeScroll(tiroir) {
    /* FLECHE RETIREE le 27/08 a la demande du proprietaire. On efface
       celle qui traine encore dans un tiroir deja rendu, puis on sort.
       RETOUR ARRIERE : supprimer ces quatre lignes, le reste de la
       mecanique (condition des 3 produits, masquage au scroll) est
       intact dessous. */
    var vieille = tiroir.querySelector('.wldr-fleche-porte');
    if (vieille) { vieille.remove(); }
    if (true) { return; }

    if (window.matchMedia('(min-width: 1000px)').matches) { return; }
    var porte = tiroir.querySelector('.wldr-fleche-porte');
    var produits = tiroir.querySelectorAll('line-item').length;
    /* la regle du proprietaire : 3 produits differents = la fleche */
    var montrer = produits >= 3 && tiroir.dataset.wldrVu !== '1';
    if (!montrer) {
      if (porte) { porte.style.display = 'none'; }
      return;
    }
    if (!porte) {
      porte = document.createElement('div');
      porte.className = 'wldr-fleche-porte';
      porte.innerHTML = '<span class="wldr-fleche">&#8595;</span>';
      tiroir.appendChild(porte);
    }
    /* posee AU-DESSUS du pied, quel que soit le defileur du telephone */
    var piedFleche = null;
    var enfantsT = tiroir.children;
    for (var pf = 0; pf < enfantsT.length; pf++) {
      if (enfantsT[pf].classList && enfantsT[pf].classList.contains('v-stack') &&
          !enfantsT[pf].classList.contains('cart-drawer__inner')) { piedFleche = enfantsT[pf]; }
    }
    var hP = piedFleche ? piedFleche.getBoundingClientRect().height : 0;
    porte.style.setProperty('bottom', Math.round(hP + 10) + 'px', 'important');
    /* le defilement — de N'IMPORTE quel conteneur du tiroir — efface la
       fleche : ecoute en phase de capture, le scroll ne bouillonne pas */
    if (tiroir.dataset.wldrRoule !== '1') {
      tiroir.dataset.wldrRoule = '1';
      tiroir.addEventListener('scroll', function (ev) {
        var el = ev.target;
        if (el && el.scrollTop > 24) {
          tiroir.dataset.wldrVu = '1';
          var p2 = tiroir.querySelector('.wldr-fleche-porte');
          if (p2) { p2.style.display = 'none'; }
        }
      }, { capture: true, passive: true });
    }
    porte.style.display = '';
  }

  function brancher() {
    var tiroir = document.querySelector('cart-drawer');
    if (!tiroir) { return false; }
    habiller();
    /* l'ouverture du tiroir : on guette son attribut/classe */
    if (window.MutationObserver && tiroir.dataset.wldrOuv !== '1') {
      tiroir.dataset.wldrOuv = '1';
      var etaitOuvert = false;
      new MutationObserver(function () {
        var ouvert = tiroir.hasAttribute('open') ||
          /\bopen\b|\bactive\b/.test(tiroir.className) ||
          tiroir.getAttribute('aria-hidden') === 'false';
        if (ouvert && !etaitOuvert) {
          window.setTimeout(function () { guiderLeScroll(tiroir); }, 120);
        }
        /* la barre de defilement de la page prend le turquoise tant que
           le tiroir est ouvert. Le CSS n'en change QUE la couleur : la
           largeur, elle, decalerait toute la page. */
        document.documentElement.classList.toggle('wldr-ouvert', ouvert);
        etaitOuvert = ouvert;
      }).observe(tiroir, { attributes: true, attributeFilter: ['open', 'class', 'aria-hidden'] });
    }
    try {
      var monde = window.matchMedia('(min-width: 1000px)');
      if (monde.addEventListener) { monde.addEventListener('change', habiller); }
    } catch (e) { /* vieux navigateurs : le placement du chargement reste */ }
    /* la barre du navigateur apparait/disparait : on recale la hauteur */
    if (window.visualViewport && !window.__wldrVV) {
      window.__wldrVV = true;
      var vvPrevu = false;
      window.visualViewport.addEventListener('resize', function () {
        if (vvPrevu) { return; }
        vvPrevu = true;
        window.setTimeout(function () { vvPrevu = false; habiller(); }, 90);
      });
    }
    if (window.MutationObserver && tiroir.dataset.wldrObs !== '1') {
      tiroir.dataset.wldrObs = '1';
      var prevu = false;
      new MutationObserver(function () {
        if (prevu) { return; }
        prevu = true;
        window.setTimeout(function () { prevu = false; habiller(); }, 60);
      }).observe(tiroir, { childList: true, subtree: true });
    }
    return true;
  }

  if (!brancher()) {
    var essais = 0;
    var minuterie = window.setInterval(function () {
      if (brancher() || ++essais > 40) { window.clearInterval(minuterie); }
    }, 500);
  }

  /* le tiroir se rouvre apres un code promo pose ou retire */
  rouvrirLeTiroir();

  /* la modale taille sur mesure ouvrira le tiroir a l'ajout ; elle peut
     arriver apres nous, d'ou les quelques tentatives */
  if (!guetterTaillePerso()) {
    var essaisTP = 0;
    var minuterieTP = window.setInterval(function () {
      if (guetterTaillePerso() || ++essaisTP > 20) { window.clearInterval(minuterieTP); }
    }, 500);
  }
})();
